<div class="custom-div" [ngStyle]="{'height': size, 'width': size, color: color}">
  <i class="ppi ppi-{{name}}"></i>
</div>
